// MonetagAds.tsx
'use client';
import { useEffect } from 'react';
import { useAuthContext } from '@/lib/AuthContext';
import { isAdmin } from '@/lib/admin';

export default function MonetagAds() {
    const { user, loading } = useAuthContext();

    useEffect(() => {
        if (loading) return;
        if (isAdmin(user?.email)) return;

        const vignette = document.body.appendChild(document.createElement('script'));
        vignette.dataset.zone = '10747608';
        vignette.src = 'https://gizokraijaw.net/vignette.min.js';

        const inPage = document.body.appendChild(document.createElement('script'));
        inPage.dataset.zone = '10747589';
        inPage.src = 'https://nap5k.com/tag.min.js';

        return () => {
            if (document.body.contains(vignette)) document.body.removeChild(vignette);
            if (document.body.contains(inPage)) document.body.removeChild(inPage);
        };
    }, [user, loading]);

    return null;
}
